import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import { getFAQsData } from 'state/actions/actions';
import FAQs from 'tailwind-components/FAQs/FAQs';

function mapStateToProps({ faqs }) {
  return {
    faqs: faqs.faqsArray
  };
}
export default connect(mapStateToProps, { getFAQsData })(
  withLocalLoader(FAQs, true, 'FAQs', 'FAQs')
);
